import { useCallback } from 'react';
import { AnimatePresence, m } from 'framer-motion';
// @mui
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
// locales
import { useLocales } from 'src/locales';
// components
import Iconify from 'src/components/iconify';
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const locales = useLocales();

  const popover = usePopover();

  const handleChangeLang = useCallback(
    (newLang) => {
      locales.onChangeLang(newLang);
      popover.onClose();
    },
    [locales, popover]
  );

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}

          sx={{
            width: 'auto',
            height: 40,
            px: 1,

            gap: 0.5,

          }}
        >
          <Iconify icon={locales.currentLang.icon} sx={{ borderRadius: 0.65, width: 28 }} />
        </IconButton>

        <AnimatePresence mode="wait" initial={false}>
          <IconButton onClick={popover.open ? popover.onClose : popover.onOpen} key={popover.open ? 'open' : 'close'}>
            <m.div
              key={popover.open ? 'open' : 'close'}
              initial={{ opacity: 0, rotate: popover.open ? -90 : 90 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: popover.open ? 90 : -90 }}
              transition={{ duration: 0.3 }}
            >
              <Iconify
                icon={popover.open ? 'mdi:expand-less' : 'lets-icons:expand-down'}
                width={20}
                sx={{ cursor: 'pointer' }}
              />
            </m.div>
          </IconButton>
        </AnimatePresence>
      </Box>


      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 160 }}>
        {locales.allLangs.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === locales.currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            <Iconify icon={option.icon} sx={{ borderRadius: 0.65, width: 28 }} />

            {option.label}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}
